import * as React from 'react';
import styled from 'styled-components';
import {Formik, Form as FormContainer} from 'formik';
import {CourseObject} from 'api/course';
import CourseBuilderContext from '../../CourseBuilderContext';
import * as Forms from './forms';

const Form = styled(FormContainer)`
  row-gap: 10px;
  display: grid;
`;

/**
 * The landing settings
 * @return {React.ReactElement}
 * @constructor
 */
export default function Landing(): React.ReactElement {
  const {
    course,
    setCourse,
  } = React.useContext(CourseBuilderContext);

  const initialValues: Partial<CourseObject> = {
    ...course,
  };

  /**
   * Handle form submit
   * @param {Partial<CourseObject>} settings
   */
  function handleSubmit(settings: Partial<CourseObject>): void {
    setCourse && setCourse({
      ...course,
      ...settings,
    });
  }

  return (
    <Formik<Partial<CourseObject>>
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {() => (
        <Form>
          <Forms.VideoForm />
          <Forms.AudienceForm />
          <Forms.BenefitForm />
          <Forms.TeachersForm />
          <Forms.AuthorMessageForm />
          <Forms.VideoMessageForm />
          <Forms.FaqForm />
        </Form>
      )}
    </Formik>
  );
}
